import { render, staticRenderFns } from "./read-more.vue?vue&type=template&id=41c8eab4&scoped=true"
import script from "./read-more.vue?vue&type=script&lang=js"
export * from "./read-more.vue?vue&type=script&lang=js"
import style0 from "./read-more.vue?vue&type=style&index=0&id=41c8eab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8eab4",
  null
  
)

export default component.exports